import { apiRequest } from "./apiClient";

export function toDesignPayload(editorData = {}, sourceModelId = null) {
    const {
        _id,
        title,
        description,
        canvasBg,
        canvasSize,
        elements,
        mode,
        duration,
        publishTo,
        startDate,
        endDate,
    } = editorData;

    return {
        _id,
        title,
        description: description ?? "",
        model: sourceModelId || null,
        duration: duration !== undefined ? duration : undefined,
        publishTo: publishTo || [],
        startDate: startDate || null,
        endDate: endDate || null,
        edit: {
            title,
            canvasBg,
            canvasSize,
            elements,
            mode: mode || "design",
        },
    };
}

export function fromApiDesign(apiDesign) {
    const edit = apiDesign?.edit || {};
    return {
        ...apiDesign,
        title: apiDesign?.title || edit.title || "Sans titre",
        description: apiDesign?.description || "",
        elements: edit.elements || [],
        canvasBg: edit.canvasBg || "#ffffff",
        canvasSize: edit.canvasSize || { width: 1080, height: 1080 },
        duration: apiDesign?.duration ?? "",
        publishTo: apiDesign?.publishTo || [],
        startDate: apiDesign?.startDate ? apiDesign.startDate.slice(0, 10) : "",
        endDate: apiDesign?.endDate ? apiDesign.endDate.slice(0, 10) : "",
    };
}

export async function listMyDesigns() {
    const designs = await apiRequest("/pub", { method: "GET" });
    return Array.isArray(designs) ? designs.map(fromApiDesign) : [];
}

export async function getDesignById(id) {
    const design = await apiRequest(`/pub/${id}`, { method: "GET" });
    return fromApiDesign(design);
}

export async function createDesign(editorData, sourceModelId = null) {
    const payload = toDesignPayload(editorData, sourceModelId);
    const design = await apiRequest("/pub", {
        method: "POST",
        body: JSON.stringify(payload),
    });
    return fromApiDesign(design);
}

export async function updateDesign(id, editorData, sourceModelId = null) {
    const payload = toDesignPayload(editorData, sourceModelId);
    const design = await apiRequest(`/pub/${id}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
    });
    return fromApiDesign(design);
}

export async function deleteDesign(id) {
    return apiRequest(`/pub/${id}`, { method: "DELETE" });
}

export async function uploadDesignPreview(id, blob) {
    const formData = new FormData();
    formData.append("file", blob, `${id}.png`);
    return apiRequest(`/pub/${id}/preview`, { method: "POST", body: formData });
}
